import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../image/right-arrow-forward.png';
import _imports_1 from '../image/occ_r_img.png';
var _hoisted_1 = {
  class: "occupation_box container"
};

var _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "occ_title"
}, "职业发展", -1);

var _hoisted_3 = {
  class: "occ_content"
};
var _hoisted_4 = {
  class: "occ_left_box col-lg-7 col-md-7 col-sm-12 col-xs-12"
};

var _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"occ_l_line\"></div><div class=\"occ_l_text_01\">我们始终热忱欢迎与元羿生物拥有共同理念、激情满怀且具备协作精神的优秀人才加入我们的团队。</div><div class=\"occ_l_text_02\">无论您是致力于早期研究、药物开发、市场营销、产品销售还是其他关键职能领域，我们都承诺为您提供具有竞争力的全面薪酬计划以及强大的职业发展平台。随着公司的迅猛发展，我们将不断为人才的成长开辟广阔的可能性和机遇。 <br> 我们诚挚地邀请您加入元羿生物，共同参与并推进公司作为医药行业新兴力量的蓬勃发展。</div><div class=\"occ_l_text_03\">欢迎投递简历：<span class=\"occ_mail\">HR@tenacia.com</span></div>", 4);

var _hoisted_9 = /*#__PURE__*/_createTextVNode(" 了解更多 ");

var _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "occ_l_arrow"
}, null, -1);

var _hoisted_11 = [_hoisted_9, _hoisted_10];

var _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "occ_right_box col-lg-5 col-md-5 col-sm-12 col-xs-12"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "occ_r_img"
})], -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", {
    class: "occ_l_btn",
    onClick: _cache[0] || (_cache[0] = function () {
      return $setup.jumpDetail && $setup.jumpDetail.apply($setup, arguments);
    })
  }, _hoisted_11)]), _hoisted_12])]);
}